module.exports = __webpack_public_path__ + "static/img/email-m.1a3c9cbc.png";